import "./../styles/competitive_exam_card.style.css";
import NativeLazyImage from "./NativeLazyImage";

export default function CompetitiveExamAdCard({
  thumbnail,
  instructorName,
  title,
  price,
  discountPrice,
  category,
  link = "#",
}) {
  return (
    <div className="card cexam-style-1 mb-3 scale-on-hover shadow-on-hover">
      <a href={link} className="text-decoration-none" target="_blank">
        <div className="img-wrap position-relative">
          {/* <img src={thumbnail} className="card-img-top img-fluid" alt="" /> */}
          <NativeLazyImage
            src={thumbnail}
            classes="card-img-top img-fluid"
            alt={title}
          />
        </div>

        <div className="card-body px-0">
          {/* <div className="d-flex _partner align-items-center">
            <div className="_partner_icon_wrap text-center">
              <FontAwesomeIcon
                icon={faGraduationCap}
                className="_highligt_icon"
                color="#0056d2"
              />
            </div>
            <span className="_partner_name">By {instructorName}</span>
          </div> */}

          <h5 className="card-title">{title}</h5>

          {/* <small className="_highlight d-block">
            <FontAwesomeIcon
              icon={faRupee}
              className="_highligt_icon"
              color="#0056d2"
            />
            <span className="_highligt_title">
              {discountPrice != null ? (
                <>
                  <del className="text-muted">{price}</del>{" "}
                  <span className="ms-2">{discountPrice}/-</span>
                </>
              ) : (
                price + "/-"
              )}
            </span>
          </small>
          <small className="_category d-block">{category}</small> */}
        </div>
      </a>
    </div>
  );
}
